/**
 * Deployment configuration.
 *
 * Browser build: nginx writes /config.js when the container starts, filling
 * window.__APP_CONFIG__ from the container's environment variables. One image
 * can therefore serve staging and production without a rebuild.
 *
 * Desktop build (Tauri): there is no server to generate that file, so the
 * values fall back to the VITE_* variables Vite inlined at build time (see
 * .env.desktop).
 *
 * Only values that differ per deployment belong here. Build-target flags such
 * as VITE_IS_DESKTOP stay in import.meta.env - they describe which app was
 * built, not where it runs.
 */

const runtime = typeof window === 'undefined' ? undefined : window.__APP_CONFIG__;

/** Runtime value first, then the compile-time default, then the local fallback. */
const read = (key, buildTimeValue, fallback) => {
  const value = runtime?.[key];
  // The generated file ships every key; unset ones are empty strings.
  if (value !== undefined && value !== '') return value;
  return buildTimeValue || fallback;
};

export const config = {
  apiBaseUrl: read('API_BASE_URL', import.meta.env.VITE_API_BASE_URL, 'http://localhost:8000/api'),
  keycloakUrl: read('KEYCLOAK_URL', import.meta.env.VITE_KEYCLOAK_URL, 'http://localhost:8080/'),
  keycloakRealm: read('KEYCLOAK_REALM', import.meta.env.VITE_KEYCLOAK_REALM, 'cloud-app'),
  keycloakClientId: read(
    'KEYCLOAK_CLIENT_ID',
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    'cloud-app-client',
  ),
  /** '' means "decide from the platform" - see hooks/useAppMode.js. */
  appMode: read('APP_MODE', import.meta.env.VITE_APP_MODE, ''),
};
